import { render, staticRenderFns } from "./PaymentsPatient.vue?vue&type=template&id=135f2a6b&scoped=true&"
import script from "./PaymentsPatient.vue?vue&type=script&lang=js&"
export * from "./PaymentsPatient.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsPatient.vue?vue&type=style&index=0&id=135f2a6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135f2a6b",
  null
  
)

export default component.exports